import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { LanguageStateProvider, initialStateEnglish, initialStateFrench } from './contexts/language-state-provider';
import { AppStateProvider, initialStateProduction } from './contexts/app-state-provider';

import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  uri: (process.env.NODE_ENV === 'development')?'http://localhost:19999/graphql':'/api/canshm/graphql',
  cache: new InMemoryCache()
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <LanguageStateProvider initialState={(document.documentElement.lang === 'fr') ? initialStateFrench : initialStateEnglish}>
        <AppStateProvider initialState={initialStateProduction}>
          <App />
        </AppStateProvider>
      </LanguageStateProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
